import { CurrencyInterface } from '../../..';

export class CurrencyDto implements CurrencyInterface {
  id: string;
  short: string;
  detailed: string;
  sign: string;
}
